
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#fff","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.857 8.705c.671-.88 1.813-.945 2.552-.145.738.8.792 2.163.121 3.043L17.466 35.295c-.694.91-1.885.944-2.614.074l-6.323-7.538c-.705-.841-.705-2.205 0-3.046.706-.841 1.85-.841 2.555 0l4.983 5.94 16.79-22.02z"}})])
          )
        }
      }
    